import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'
import Spacer from 'atoms/Spacer'
import TextInput from 'atoms/TextInput'
import FieldLayout from '../FieldLayout'

export default class ProposalDescriptionEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
  }

  handleSave = (url) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, { url })
      }
    })
  }

  render() {
    const { field } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Quick link">
          <TextInput
            required
            url
            maxLength={512}
            placeholder="Enter link URL..."
            defaultValue={field.url || ''}
            onSave={this.handleSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
